var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-card',{staticClass:"ma-3 pa-3"},[_c('h1',[_vm._v("These are the terms")]),_vm._v(" Thank you ")])
}
var staticRenderFns = []

export { render, staticRenderFns }